'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _modalsRegistry = require('../../hoc/modalsRegistry');

var _modalsRegistry2 = _interopRequireDefault(_modalsRegistry);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalWrapper =
/*#__PURE__*/
function (_react2$default$Compo) {
  _inherits(ModalWrapper, _react2$default$Compo);

  function ModalWrapper() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalWrapper);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalWrapper)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.el = document.createElement('div'), _temp));
  }

  _createClass(ModalWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          id = _this$props.id,
          modals = _this$props.modals;
      modals.register(id);

      if (modals.container) {
        modals.container.appendChild(this.el);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          modals = _this$props2.modals;
      modals.unregister(id);

      if (modals.container && modals.container.contains(this.el)) {
        modals.container.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          Modal = _this$props3.Modal,
          _this$props3$modalPro = _this$props3.modalProps,
          modalProps = _this$props3$modalPro === void 0 ? {} : _this$props3$modalPro,
          _this$props3$modals = _this$props3.modals,
          active = _this$props3$modals.active,
          close = _this$props3$modals.close,
          params = _this$props3$modals.params;
      return active === id ? _reactDom2.default.createPortal(_react2.default.createElement(Modal, _extends({}, modalProps, params, {
        close: close
      })), this.el) : null;
    }
  }]);

  return ModalWrapper;
}(_react2.default.Component);

exports.default = (0, _redux.compose)(_modalsRegistry2.default)(ModalWrapper);